import update from 'immutability-helper';
import * as types from './types';
import { ManualAlertEvent, ManualAlert } from '@conviva/portal-graphql-schema';

export interface IState {
  selectedEvent: ManualAlertEvent | null;
  showAlerts: boolean;
  matchingAlerts: ManualAlert[];
}

const initialState: IState = {
  selectedEvent: null,
  showAlerts: false,
  matchingAlerts: [],
};

const switchMap: {
  [key in keyof typeof types]?: (state: IState, action: Partial<{ type: keyof
 typeof types }>) => string;
} = {};

switchMap[types.SET_SELECTED_EVENT] = (state: IState, action) => update(state, {
  selectedEvent: {
    $set: action.event,
  },
});

switchMap[types.SET_MATCHING_ALERTS] = (state: IState, action) => update(state, {
  matchingAlerts: {
    $set: action.alerts,
  },
});

switchMap[types.SET_SHARING_STATE] = (state: IState, action) => update(state, {
  $set: action.state,
});

switchMap[types.TOGGLE_SHOW_ALERTS] = (state: IState, action) => update(state, {
  showAlerts: {
    $set: action.status,
  },
  selectedEvent: {
    $set: action.status === false ? null : state.selectedEvent,
  }
});

export default (state = initialState, action) => (
  switchMap[action.type]
    ? switchMap[action.type](state, action)
    : state
);
